const EventTypes = {
	AppLocalSliderClose			: 'app-local:slider-on-close',
	AppSliderSliderClose		: 'app-slider:slider-on-close',
	AppUninstalledSliderClose	: 'app-uninstalled:slider-on-close'
};

export
{
	EventTypes
}